import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['option', 'hiddenInput'];

  connect() {
    // Check if there's a pre-selected value
    const currentValue = this.hiddenInputTarget.value;
    if (currentValue) {
      const selectedOption = this.optionTargets.find(
        (option) => option.dataset.value === currentValue
      );
      if (selectedOption) {
        this.selectOption(selectedOption);
      }
    }
  }

  select(event) {
    const selectedOption = event.currentTarget;
    this.selectOption(selectedOption);
  }

  selectOption(option) {
    // Deselect all options first
    this.optionTargets.forEach((opt) => {
      opt.classList.remove('bg-pink-tags', 'border-pink-tags-stroke');
      opt.classList.add('bg-base-200', 'text-gray-900');
    });

    // Select the clicked option
    option.classList.remove('bg-base-200', 'text-gray-900');
    option.classList.add('bg-pink-tags', 'border-pink-tags-stroke');

    // Update the hidden input value
    this.hiddenInputTarget.value = option.dataset.value;
  }
}
